function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m487.453 107.224-43.161-74.757a14.069 14.069 0 0 0-12.184-7.034h-86.322a14.07 14.07 0 0 0-12.184 7.034l-42.083 72.891 63.139 97.727h77.45a14.07 14.07 0 0 0 12.184-7.034l43.161-74.757a14.072 14.072 0 0 0 0-14.07z",
    style: {},
    fill: "#bbec6c",
    "data-original": "#bbec6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.453 107.224 471.758 80.04l-46.926 81.278A15.363 15.363 0 0 1 411.527 169h-78.89l22.021 34.084h77.45a14.07 14.07 0 0 0 12.184-7.034l43.161-74.757a14.07 14.07 0 0 0 0-14.069z",
    style: {},
    fill: "#a2e62e",
    "data-original": "#a2e62e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.665 40.5 119.999 221.075c-63.331 98.023 7.034 227.259 123.736 227.259h.001c116.702 0 187.067-129.236 123.736-227.259L250.806 40.5c-3.317-5.132-10.825-5.132-14.141 0z",
    style: {},
    fill: "#99e6fc",
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.665 40.5 119.999 221.075c-63.331 98.023 7.034 227.259 123.736 227.259h.001c116.702 0 187.067-129.236 123.736-227.259L250.806 40.5c-3.317-5.132-10.825-5.132-14.141 0z",
    style: {},
    fill: "#c8effe",
    "data-original": "#c8effe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.822 230.006C362.686 318.37 287.648 387 196.569 387c-30.99 0-60.12-7.953-85.474-21.918 23.161 47.821 71.542 83.252 132.64 83.252h.001c113.19 0 182.784-121.574 129.086-218.328z",
    style: {},
    fill: "#99e6fc",
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.751,
    cy: 248.655,
    r: 30.251,
    style: {},
    fill: "#99e6fc",
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.321 220.306a30.19 30.19 0 0 1 1.68 9.943c0 16.707-13.544 30.251-30.251 30.251-3.719 0-7.279-.675-10.57-1.902 4.114 11.821 15.348 20.308 28.57 20.308 16.707 0 30.251-13.544 30.251-30.251.001-12.988-8.186-24.061-19.68-28.349z",
    style: {},
    fill: "#62dbfb",
    "data-original": "#62dbfb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.209,
    cy: 402.728,
    r: 83.839,
    style: {},
    fill: "#01c0fa",
    "data-original": "#01c0fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.76 327.261c10.202 13.887 16.24 31.024 16.24 49.578 0 46.303-37.536 83.839-83.839 83.839-13.104 0-25.503-3.011-36.551-8.371 15.26 20.771 39.849 34.261 67.599 34.261 46.303 0 83.839-37.536 83.839-83.839 0-33.199-19.299-61.887-47.288-75.468z",
    style: {},
    fill: "#08a9f1",
    "data-original": "#08a9f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.194 330.712H56.219a12.21 12.21 0 0 0-10.574 6.105l-25.987 45.011a12.21 12.21 0 0 0 0 12.21l25.987 45.011a12.21 12.21 0 0 0 10.574 6.105h51.974a12.21 12.21 0 0 0 10.574-6.105l25.987-45.011a12.21 12.21 0 0 0 0-12.21l-25.987-45.011a12.207 12.207 0 0 0-10.573-6.105z",
    style: {},
    fill: "#fd8087",
    "data-original": "#fd8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.755 381.828-16.408-28.42-31.133 53.924A13.337 13.337 0 0 1 85.664 414H31.183l14.462 25.049a12.21 12.21 0 0 0 10.574 6.105h51.974a12.21 12.21 0 0 0 10.574-6.105l25.987-45.011a12.208 12.208 0 0 0 .001-12.21z",
    style: {},
    fill: "#fe646f",
    "data-original": "#fe646f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.846,
    cy: 119.313,
    r: 86.623,
    style: {},
    fill: "#ffd15b",
    "data-original": "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.732 41.397c10.991 14.521 17.515 32.611 17.515 52.227 0 47.841-38.783 86.623-86.623 86.623-13.587 0-26.441-3.131-37.886-8.707 15.815 20.894 40.884 34.397 69.109 34.397 47.841 0 86.623-38.783 86.623-86.623-.001-34.255-19.885-63.862-48.738-77.917z",
    style: {},
    fill: "#ffc344",
    "data-original": "#ffc344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.729 231.325h-28.263a6.64 6.64 0 0 0-5.75 3.32l-14.131 24.476a6.64 6.64 0 0 0 0 6.64l14.131 24.476a6.64 6.64 0 0 0 5.75 3.32h28.263a6.64 6.64 0 0 0 5.75-3.32l14.131-24.476a6.64 6.64 0 0 0 0-6.64l-14.131-24.476a6.64 6.64 0 0 0-5.75-3.32z",
    style: {},
    fill: "#99e6fc",
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.61 259.122-11.625-20.135-17.45 30.224a7.58 7.58 0 0 1-6.564 3.79h-28.208l9.952 17.238a6.64 6.64 0 0 0 5.75 3.32h28.263a6.64 6.64 0 0 0 5.75-3.32l14.131-24.476a6.635 6.635 0 0 0 .001-6.641z",
    style: {},
    fill: "#62dbfb",
    "data-original": "#62dbfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.8 127.124 9.074-50.272c.227-1.177 1.869-1.287 2.251-.151l14.761 50.031c.358 1.066 1.868 1.058 2.215-.011l14.257-50.011c.37-1.14 2.012-1.047 2.252.127l9.611 50.287M413.239 148.071c-1.512-1.934 2.579 5.056 15.731 4.512 14.786-.611 14.12-17.276 14.12-17.276V94.578",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.676,
    cy: 111.996,
    r: 17.418,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.787 205.925-9.789 15.151c-9.55 14.782-16.047 30.274-19.815 45.925M389.757 321.671c4.837-33.128-1.568-68.531-22.285-100.596L250.806 40.5c-3.316-5.133-10.824-5.133-14.141 0l-28.46 44.05M138.729 404.474c26.002 26.631 62.411 43.86 105.005 43.86h.001c32.896 0 62.107-10.271 85.683-27.214M96.202 302a146.212 146.212 0 0 0 3.126 28.712M146.003 249.473v72.516M196.185 249.473v72.516M146.003 284.487h50.182",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.208,
    cy: 282.546,
    r: 36.258,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94 371.618s-29.517.371-30.915-.095c-1.398-.466 2.242-2.928 21.594-30.579 3.614-5.164 5.604-9.521 6.45-13.171l.3-2.347c0-8.574-6.95-15.524-15.524-15.524-7.544 0-13.831 5.381-15.232 12.515M66.55 360.629v54.607M95.924 361.318l-27.626 25.395 29.565 28.523M403.821 380.076a27.187 27.187 0 0 0-15.274-4.665c-15.087 0-27.318 12.231-27.318 27.318s12.231 27.318 27.318 27.318c6.128 0 11.168-2.017 14.993-5.424a21.894 21.894 0 0 0 2.217-2.288",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.754,
    cy: 409.161,
    r: 18.434,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.189 388.276v41.77",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.209,
    cy: 402.728,
    r: 83.839,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.194 330.712H56.219a12.21 12.21 0 0 0-10.574 6.105l-25.987 45.011a12.21 12.21 0 0 0 0 12.21l25.987 45.011a12.21 12.21 0 0 0 10.574 6.105h51.974a12.21 12.21 0 0 0 10.574-6.105l25.987-45.011a12.21 12.21 0 0 0 0-12.21l-25.987-45.011a12.207 12.207 0 0 0-10.573-6.105zM44.25 138c8.545 38.857 43.172 67.937 84.596 67.937 47.841 0 86.623-38.783 86.623-86.623S176.687 32.69 128.846 32.69c-42.263 0-77.451 30.269-85.083 70.31",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.866 146.674V89.869l38.406 55.614c.712 1.029 1.475.525 1.475-.726l-.532-54.994",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.624,
    cy: 124.919,
    r: 19.202,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.826 103.163v43.511",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.751,
    cy: 248.655,
    r: 30.251,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.729 231.325h-28.263a6.64 6.64 0 0 0-5.75 3.32l-14.131 24.476a6.64 6.64 0 0 0 0 6.64l14.131 24.476a6.64 6.64 0 0 0 5.75 3.32h28.263a6.64 6.64 0 0 0 5.75-3.32l14.131-24.476a6.64 6.64 0 0 0 0-6.64l-14.131-24.476a6.64 6.64 0 0 0-5.75-3.32zM355.848 203.084h76.259a14.07 14.07 0 0 0 12.184-7.034l43.161-74.757a14.07 14.07 0 0 0 0-14.069l-43.161-74.757a14.069 14.069 0 0 0-12.184-7.034H404M369 25.433h-23.214a14.07 14.07 0 0 0-12.184 7.034l-41.521 71.918",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniral);
export default __webpack_public_path__ + "static/media/miniral.4d77c9e21c6b4210a06cced171275708.svg";
export { ForwardRef as ReactComponent };